import { useMutation, useQueryClient } from "@tanstack/react-query";
import { neWebApi } from "../../../../api";
import { neWebUrls } from "../../../../ne-web-urls";
import type { PPAInvoiceId } from "../PPAInvoicePage.types";
import { ppaDeliveryInvoicesQueryOptions } from "./usePPADirectDeliveryInvoices";

export function useVoidInvoice() {
  const queryClient = useQueryClient();

  const voidInvoiceMutation = useMutation({
    mutationFn: (ppaInvoiceId: PPAInvoiceId) => voidInvoice(ppaInvoiceId),
    onSuccess: handleSuccess
  });

  async function handleSuccess() {
    await queryClient.invalidateQueries({
      queryKey: ppaDeliveryInvoicesQueryOptions.queryKey
    });
  }

  return { voidInvoiceMutation };
}

async function voidInvoice(ppaInvoiceId: PPAInvoiceId) {
  return neWebApi.post(neWebUrls.api.ppaVoidInvoice(), {
    unique_identifier: ppaInvoiceId
  });
}
